/**
 * Created by JasonChou on 16/12/12.
 */
import {
  getEditorInfo,
  getEditorFlow,
  getPageSubLayoutList
} from '../../apis/app_api'

import {
  getRoles as getRolesApi
} from '../../apis/common'
import {
  saveControls as savePageControlsApi,
  savePage as savePageApi,
  deletePage as deletePageApi,
  get as getPageApi,
  getPages as getPagesApi,
  clone,
  cloneBehind,
  cloneAfter,
  getPageControls,
  getPageFlows,
} from '../../apis/page_apis'

import {
  completeDefineByDefault,
  completePropsByDefine,
  checkSubmitProps
} from '../../utils/controlUtils'
import {
  getRightControlsWithType,
  getEditTypeOfPageId,
  getPageEditFlag,
  arrayToMaps
} from '../../utils/utils'


import { treeListToMap, mapToTreeList } from 'utils/controlDetacher.js'
import { cacheComponent } from 'constant/controlMenus'


function getControlNameIndex (control) {
  if (!control.name) return NaN;
  if (control.name.startsWith(control.type)) {
    const index = parseInt(control.name.substring(control.type.length));
    return index < 0 ? -index : index;
  }
}

function generatePageControlIndex (controls, result = {}) {
  if (!controls) return result
  controls.map((control) => {
    const index = getControlNameIndex(control);
    if (index) {
      if (!result[control.type] || index > result[control.type]) {
        result[control.type] = index;
      }
    }

    // travel children
    if (control.children && control.children.length) {
      generatePageControlIndex(control.children, result);
    }
  });
  return result;
}

export const setDefineMap = (store, type, k, v) => {
  dispatch('SET_DEFINE_MAP', type, k, v);

}
export const initEditorAppService = (store, app, services) => {
  const { dispatch, state } = store;
  dispatch('SET_APP_INFO', app);
  dispatch('INIT_SERVICE', services, []);
}

export const initAppInfoFromRemote = (store, app_id, page_id) => {
  let {
    dispatch,
    state
  } = store;
  return getEditorInfo(app_id, page_id).then((res) => {
    let {
      app = {},
      controlDefines = {},
      currentPage = {},
      controlsData = { childrenIds: [], controls: {} },
      project = {},
      tables,
      pageMaps,
      serverTime,
      flows, // 流程图列表
      controlVipSettings,
      services, // 三方插件列表
      interfaces, // 三方插件接口配置列表
      pageTypes,
      controlTypes,
      relationPages
    } = res.data.data || {};
    const childrenIds = controlsData.childrenIds
    const controls = controlsData.controls

    // console.log('editor.info', res);
    console.log('controls', controls);
    let { controlList, controlsMap } = mapToTreeList(childrenIds, controls);
    // TODO: combine hex components define to sets
    controlDefines.custom = controlDefines.custom.concat(Object.keys(cacheComponent.defines).map(x => cacheComponent.defines[x]))
    // console.log('components defines', controlDefines)
    // 初始化后端定义的defineMaps
    for (const key of Object.keys(controlDefines)) {
      let defines = controlDefines[key];
      if (Array.isArray(defines)) {
        defines.map(define => completeDefineByDefault(define));
      }
    }
    // console.log('IIIIIIN', controlDefines)
    app.pageTypes = pageTypes
    app.controlTypes = controlTypes
    currentPage.controls = controlList;

    dispatch('INIT_EDITOR', controlDefines, controlVipSettings);
    let selectedControls = [];
    let widgets = currentPage.widgets || [];
    let extra = currentPage.extra || {};
    // console.log('state.editor.controlDefinesMap', state.editor.controlDefinesMap)
    Object.keys(controls).map(controlId => {
      completePropsByDefine(controls[controlId], state.editor.controlDefinesMap);
    });

    currentPage.controls.forEach(ctrl => {
      completePropsByDefine(ctrl, state.editor.controlDefinesMap);
    })

    pageMaps = arrayToMaps(pageMaps, 'spider_url')
    dispatch('INIT_APP_INFO', app, currentPage, pageMaps, serverTime);
    // console.log('currentPage', currentPage)
    dispatch('SELECT_PAGE', {
      controlList,
      controlsMap,
      childrenIds,
      selectedControls,
      widgets,
      pageInfo: currentPage,
      extra
    });
    dispatch('SELECT_PROJECT', project);
    dispatch('INIT_TABLES', tables);
    dispatch('INIT_OSSES', project.ossList);

    dispatch('SET_APP_FLOWS', flows);

    dispatch('INIT_SERVICE', services, interfaces);

    const result = generatePageControlIndex(currentPage.controls);
    dispatch('INIT_CONTROLS_INDEX', result);

    checkPagesCache(store, true);
    updatePageControls(store, currentPage.page_id, currentPage.controls);
    // console.log('currentPage.controls', currentPage.controls);

    // 关联页面处理
    setTimeout(() => {
      for (const page of relationPages) {
        dispatch('UPDATE_PAGE_CONTROLS', page.page_id, page.controls);
      }
    }, 1000);

    // getPageSubLayoutList(app_id, page_id).then(res => {
    //   if (res.ok) {
    //     const subPages = res.data.data;
    //     for (const subPage of subPages) {
    //       const childrenIds = subPage.controlsData.childrenIds;
    //       const controls = subPage.controlsData.controls;
    //       let { controlList } = mapToTreeList(childrenIds, controls);
    //       subPage.currentPage.controls = controlList;
    //       dispatch('UPDATE_PAGE_CONTROLS', subPage.currentPage.page_id, subPage.currentPage.controls);
    //     }
    //   }
    // });
    return res;
  })
};

export const updateFlowInitial = ({ dispatch }, flows) => {
  dispatch('UPDATE_APP_FLOWS', flows);
}

export const clonePage = (store, page_id) => {
  let {
    state
  } = store;
  return cloneBehind(state.app.appInfo._id, page_id).then(res => {
    if (res.ok)
      return res;
  });
};

export const clonePageNew = (store, page_id, flows) => {
  let {
    state
  } = store;
  return cloneAfter(state.app.appInfo._id, page_id, flows).then(res => {
    if (res.ok)
      return res;
  });
};

export const updateSelectPage = (store, page) => {
  let {
    dispatch
  } = store;
  // console.log('update select page', page)
  dispatch('SELECT_PAGE', {
    pageInfo: page,
    widgets: page.widgets,
  });
};

/**
 * 切换页面 (调用远程)
 * @param store
 * @param page_id
 * @returns {Promise.<TResult>|*}
 */
export const changePage = (store, page_id) => {
  let {
    dispatch,
    state
  } = store;
  return getPageApi(state.app.appInfo._id, page_id).then(res => {
    let page = res.data.data;
    // console.log('xxx', page)
    let { childrenIds, controls } = page.controlsData
    let { controlList, controlsMap } = mapToTreeList(childrenIds, controls)

    let widgets = page.widgets || [];
    let extra = page.extra || {};

    controlList.map(control => {
      completePropsByDefine(control, state.editor.controlDefinesMap);
    });

    page.controls = controlList

    dispatch('SELECT_PAGE', {
      controlList,
      controlsMap,
      childrenIds,
      selectedControls: [],
      widgets,
      pageInfo: page,
      extra
    });

    const result = generatePageControlIndex(controlList);
    dispatch('INIT_CONTROLS_INDEX', result);

    checkPagesCache(store, false);
    getPageSubLayoutList(page.app_id, page.page_id).then(res => {
      if (res.ok) {
        const subPages = res.data.data;
        for (const subPage of subPages) {
          const childrenIds = subPage.controlsData.childrenIds;
          const controls = subPage.controlsData.controls;
          let { controlList } = mapToTreeList(childrenIds, controls);
          subPage.currentPage.controls = controlList;
          dispatch('UPDATE_PAGE_CONTROLS', subPage.currentPage.page_id, subPage.currentPage.controls);
        }
      }
    });
    return res;

  })
};

/**
 * 保存应用信息
 */
export const setAppInfo = ({
  dispatch
}, appinfo) => {
  dispatch('SET_APP_INFO', appinfo)
};

export const savePage = ({
  dispatch,
  state
},
  page_id,
  name,
  path,
  desc,
  keywords,
  isHomepage,
  urlParams,
  extra,
  initDataSource,
  height,
  width,
  layoutType,
  type,
  eventList,
  widgets,
  datas,
  isComponent
) => {
  const editType = getEditTypeOfPageId(state, page_id);
  // console.log(editType);
  return savePageApi(
    state.app.appInfo._id,
    page_id,
    name,
    path,
    desc,
    keywords,
    isHomepage,
    urlParams,
    extra,
    initDataSource,
    height,
    width,
    layoutType,
    type,
    eventList,
    widgets,
    datas,
    isComponent
  ).then((res) => {
    if (res.ok) {
      dispatch('UPDATE_PAGE_INFO', {
        name,
        path,
        desc,
        keywords,
        isHomepage,
        urlParams,
        extra,
        initDataSource,
        height,
        width,
        layoutType,
        type,
        eventList
      })
      updateSaveTime({
        dispatch,
      }, res.data.data);
    }
    return res
  });
};

export const deletePage = ({
  state
}, page_id) => {
  return deletePageApi(state.app.appInfo._id, page_id, state.userInfo._id);
};

export const addPage = ({
  state, dispatch
}, page) => {
  dispatch('ADD_PAGE', page);
};

function saveCommonPageControls ({
  dispatch,
  state
}, editType, force) {
  let controls = [];
  dispatch("CHANGE_SAVE_STATUS", "saving");
  const emptyPromise = new Promise((resolve) => {
    resolve({
      ok: true,
    });
  });

  const currentPage = state.page.pageInfo;
  if (!currentPage) {
    // console.log('save page error! ', editType);
    dispatch("CHANGE_SAVE_STATUS", "saved");
    return emptyPromise;
  }

  if (!getPageEditFlag(state, editType)) {
    dispatch("CHANGE_SAVE_STATUS", "saved");
    return emptyPromise;
  }
  getRightControlsWithType(state, editType).map((control) => {
    checkSubmitProps(controls, control);
  });

  if (!controls && (!currentPage.widgets || currentPage.widgets.length === 0)) {
    dispatch("CHANGE_SAVE_STATUS", "saved");
    return emptyPromise;
  }

  return savePageControlsApi(state.app.appInfo._id, currentPage.page_id, controls, state.page.widgets, currentPage.hex_modify_time_stamp, state.userInfo._id, force)
    .then((res) => {
      // console.log('app save page control', res)
      if (res.ok) {
        updateSaveTime({
          dispatch,
        }, res.data.data);
        dispatch("CHANGE_SAVE_STATUS", "saved");
        const mutationString = state.app.editType.toUpperCase() + '_UPDATE_MODIFY_FLAG';
        // console.log(mutationString);
        dispatch(mutationString, false);
      }

      return new Promise((resolve) => {
        resolve(res);
      });
    });
}

export const savePageControls = ({
  dispatch,
  state
}, force = false) => {
  return saveCommonPageControls({
    dispatch,
    state
  }, 'page', force);
};

export const changeLayoutSwitch = ({ dispatch }, isSwitch) => {
  dispatch('SET_APP_LAYOUT_SWITCH', isSwitch)
}


export const updateSaveTime = ({
  dispatch,
}, timeStamp) => {
  dispatch('UPDATE_SAVE_TIME', timeStamp);
  dispatch('SAVE_PAGE_CONTROLS');
};

export const getRoles = ({
  state
}, offset = 0, limit = 10) => {
  return getRolesApi(state.app.appInfo._id, offset, limit);
};

export const checkPagesCache = ({
  state,
  dispatch
}, force = false) => {
  if (force || !state.app.pages || state.app.pages.length === 0) {
    dispatch('CLEAN_CONTROLS_TEMPLATE');
    getPagesApi(state.app.appInfo._id).then(res => {
      dispatch('REFRESH_PAGES_CACHE', res.data.data);
    });
  }
};

export const completePageControls = ({
  state,
  dispatch
}, pageId, appId, nocheck = false) => {
  dispatch('READ_CONTROLS_FROM_TEMPLATE');
  const page = state.app.pages.find(page => page.page_id === pageId);
  if ((page && page.controls === null) || nocheck) {
    getPageControls(appId, pageId).then((res) => {
      if (res.ok) {
        const pageInfo = res.data.data
        // console.log('YYYYYY', pageInfo)
        const controls = mapToTreeList(pageInfo.controlsData.childrenIds, pageInfo.controlsData.controls).controlList
        dispatch('UPDATE_PAGE_CONTROLS', pageId, controls);
      }
    });
  } else {
    // console.warn('in app action completePageControls, got null page, pageId', pageId);
    // 无需拉取
  }
  return true;
};

export const updatePageControls = ({
  dispatch
}, pageId, controls) => {
  if (Object.prototype.toString.call(controls) === '[object Object]') {
    controls = controls.controls
  }
  dispatch('UPDATE_PAGE_CONTROLS', pageId, controls);
};

export const refreshPagesCache = ({
  dispatch
}, pages) => {
  dispatch('REFRESH_PAGES_CACHE', pages);
};

export const updatePagesCache = ({
  dispatch
}, pageID, page = null) => {
  dispatch('UPDATE_PAGES_CACHE', pageID, page);
};

export const completeLayoutControls = (({
  dispatch,
  state
}, page_id) => {
  return getPageApi(state.app.appInfo._id, page_id).then(res => {
    let pageInfo = res.data.data;

    // 转换为标准的controls
    // pageInfo.controls = mapToTreeList(pageInfo.controlsData.childrenIds, pageInfo.controlsData.controls)

    pageInfo.controls = mapToTreeList(pageInfo.controlsData.childrenIds, pageInfo.controlsData.controls).controlList

    pageInfo && pageInfo.controls.map(control => {
      completePropsByDefine(control, state.editor.controlDefinesMap);
    });
    return pageInfo;
  });
});
export const changeEditType = ({
  dispatch
}, editType) => {
  dispatch('CHANGE_EDIT_TYPE', editType);
};

/** flow actions */
export const chooseFlow = (state, flow) => {
  const { dispatch } = state;
  dispatch('CHOOSE_FLOW', flow);
  // TODO: 拉取对应页面控件数据, 控件选择组件支持传递page_id
  // if (flow.type === 'front') {
  //   completePageControls(state, flow.page_id, flow.app_id);
  // }
}

export const addFlow = ({ dispatch }, flow) => {
  dispatch('ADD_FLOW', flow);
}

export const updateFlow = ({ dispatch }, flow) => {
  dispatch('UPDATE_FLOW', flow);
}

export const changeFlowInfo = ({ dispatch }, key, value) => {
  dispatch('CHANGE_FLOW', key, value);
}

export const deleteFlow = ({ dispatch }, id) => {
  dispatch('DELETE_FLOW', id);
}

export const changeFlowNodes = ({ dispatch }, node, type) => {
  dispatch('SET_APP_FLOW_NODES', node, type);
}

export const setOpenLists = ({ dispatch }, lists) => {
  dispatch('SET_FLOW_OPENLISTS', lists);
}

export const changeEditorFlowTabType = ({
  dispatch
}, editorFlowTabStatus) => {
  dispatch('CHANGE_EDITOR_TAB_FLOW_TYPE', editorFlowTabStatus);
};

/**
 * 切换页面补全流程图列表 FLOWS 信息
 * @param {*} pageId 页面ID
 * @param {*} appId 应用ID
 * @param {*} flows 当前流程图列表
 */
export const completePageFlows = ({ state, dispatch }, pageId, appId, flows) => {
  const exists = flows.find(item => item.page_id === pageId);
  if (exists) {
    // console.log("无需拉取");
    return true;
  }
  if (pageId && appId) {
    getPageFlows(appId, pageId).then((res) => {
      // console.log('当前页面流程图', res);
      for (const flow of res) {
        // console.log("ADD FLOW", flow);
        dispatch('ADD_FLOW', flow);
        dispatch('CHOOSE_FLOW', flow)
      }
    })
  }
};
/** 获取更新单个流程图 */
export const setAppFlow = ({ state, dispatch }, flow) => {
  return new Promise((resolve) => {
    getEditorFlow(flow._id).then(res => {
      if (res.status === 200) {
        // console.log(res.body.data)
        let newflow = res.body && res.body.data
        // 如果新流程信息存在, 将流程保存到 vuex flows
        newflow && dispatch('SET_APP_FLOW', newflow);
        resolve(newflow || null)
      }
      resolve(null)
    })
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/app_actions.js